import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const PHOTOS = [
  { src: "/images/foto-c.jpg", alt: "Rollè di pollo con patate al forno" },
  { src: "/images/foto-b.jpg", alt: "Cosciotto arrosto con patate al forno" },
  { src: "/images/wings.jpg", alt: "Alette di pollo speziate con patate croccanti" },
  { src: "/images/piatto.jpg", alt: "Ali di pollo e patate al forno di Mister Pollo" },
];

export const PhotoSlider = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % PHOTOS.length), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="manifesto-photo" className="relative aspect-[4/5] overflow-hidden rounded-t-[999px] rounded-b-[2rem] border border-white/10 bg-[#16161A]">
      <AnimatePresence initial={false}>
        <motion.img
          key={PHOTOS[i].src}
          src={PHOTOS[i].src}
          alt={PHOTOS[i].alt}
          initial={{ opacity: 0, scale: 1.08 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 w-full h-full object-cover object-[center_65%]"
        />
      </AnimatePresence>
      <div className="absolute bottom-5 inset-x-0 flex justify-center gap-2 z-10">
        {PHOTOS.map((p, n) => (
          <button
            key={p.src}
            type="button"
            aria-label={`Foto ${n + 1}`}
            data-testid={`photo-slider-dot-${n}`}
            onClick={() => setI(n)}
            className={`h-2 rounded-full transition-[width,background-color] duration-500 ${n === i ? "w-7 bg-[#FF5500]" : "w-2 bg-white/60 hover:bg-white"}`}
          />
        ))}
      </div>
    </div>
  );
};
